import { useState, useReducer } from "react";

export default function useMachine(chart, reducer, initialData) {
  let [state, setState] = useState(chart.initial);
  let [data, dispatch] = useReducer(reducer, initialData);

  let transition = (action, payload = {}) => {
    let nextState = chart[state][action];
    dispatch({ type: action, state, nextState: state, ...payload });
    setState(nextState);
  };

  return [state, data, transition];
}

export function useMachineWithLogger(chart, reducer, initialData) {
  let [state, data, transition] = useMachine(chart, reducer, initialData);

  function loggedTransition(action, payload = {}) {
    let nextState = chart[state][action];
    console.group("useSimpleMachine");
    console.log({ action }, payload);
    console.log({ state, nextState });
    console.log("data", data);
    console.log(
      "nextData",
      reducer(data, { type: action, state, nextState: state, ...payload })
    );
    console.groupEnd();
    transition(action, payload);
  }

  return [state, data, loggedTransition];
}



// WEBPACK FOOTER //
// ./src/useMachine.js